import { ConfirmationDialog } from '@acp/core-ui';
import { useDisclosure } from '@chakra-ui/react';

export function ConfirmCloseDialog({
    alertDialogDisclosure,
    handleClose,
}: {
    alertDialogDisclosure: ReturnType<typeof useDisclosure>;
    handleClose: () => void;
}) {
    return (
        <ConfirmationDialog
            isOpen={alertDialogDisclosure.isOpen}
            title="Are you sure you want to close without saving your changes?"
            confirmText="Close without saving changes"
            onCancel={alertDialogDisclosure.onClose}
            onConfirm={handleClose}
        >
            Changes made to this tenancy will be lost if you close this
            dialog.
        </ConfirmationDialog>
    );
}
